export const bugbountyPosts = [
  {
    id: 'bb1',
    user_id: 'user131',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Google VRP $50,000 보상 - Chrome V8 RCE 취약점 발견기',
    content: 'Google Vulnerability Reward Program에서 $50,000 보상을 받은 Chrome V8 엔진의 RCE 취약점 발견 과정을 공유합니다. 퍼징으로 크래시를 발견하고, 루트 원인을 분석하여 익스플로잇을 작성하기까지의 전 과정을 상세히 설명합니다.',
    tags: ['bugbounty', 'google', 'chrome', 'v8', 'rce'],
    status: 'open',
    is_pinned: false,
    likes_count: 3456,
    replies_count: 128,
    views_count: 28900,
    created_at: new Date(Date.now() - 1 * 3600000).toISOString(),
    profiles: {
      id: 'user131',
      username: 'bounty_hunter_pro',
      display_name: 'Bounty Hunter Pro',
      points: 19870,
      reputation: 6120
    }
  },
  {
    id: 'bb2',
    user_id: 'user132',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 1년 수익 공개 - $120,000 달성 전략',
    content: '버그바운티로 1년간 $120,000를 벌어들인 경험을 공개합니다. 타겟 선정 전략, 시간 관리, 효율적인 테스팅 방법론, 그리고 리포트 작성 노하우까지 모든 것을 공유합니다. 월별 수익 그래프와 함께 상세한 분석을 제공합니다.',
    tags: ['bugbounty', 'income', 'strategy', 'full-time', 'success'],
    status: 'open',
    is_pinned: false,
    likes_count: 4123,
    replies_count: 156,
    views_count: 34200,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: {
      id: 'user132',
      username: 'fulltime_hunter',
      display_name: 'Full-time Hunter',
      points: 21450,
      reputation: 6780
    }
  },
  {
    id: 'bb3',
    user_id: 'user133',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'HackerOne 상위 1% 헌터의 IDOR 찾기 방법론',
    content: 'HackerOne에서 상위 1%에 랭크된 제 IDOR 취약점 발견 방법론을 공유합니다. 자동화 도구 활용, 패턴 인식, 그리고 창의적인 테스트 케이스 작성법을 다룹니다. 실제 발견한 IDOR 사례 20개와 함께 설명합니다.',
    tags: ['bugbounty', 'hackerone', 'idor', 'methodology', 'automation'],
    status: 'open',
    is_pinned: false,
    likes_count: 2876,
    replies_count: 104,
    views_count: 23400,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: {
      id: 'user133',
      username: 'idor_specialist',
      display_name: 'IDOR Specialist',
      points: 18230,
      reputation: 5670
    }
  },
  {
    id: 'bb4',
    user_id: 'user134',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Facebook $40,000 보상 - Account Takeover 체인 공격',
    content: 'Facebook에서 $40,000 보상을 받은 Account Takeover 취약점을 공개합니다. OAuth 구현 오류, CSRF, 그리고 레이스 컨디션을 연계한 복잡한 공격 체인이었습니다. 발견부터 검증, 리포트 작성까지의 과정을 상세히 설명합니다.',
    tags: ['bugbounty', 'facebook', 'account-takeover', 'oauth', 'chain'],
    status: 'open',
    is_pinned: false,
    likes_count: 3234,
    replies_count: 117,
    views_count: 26700,
    created_at: new Date(Date.now() - 7 * 3600000).toISOString(),
    profiles: {
      id: 'user134',
      username: 'ato_master',
      display_name: 'ATO Master',
      points: 17890,
      reputation: 5450
    }
  },
  {
    id: 'bb5',
    user_id: 'user135',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 초보자 가이드 - 첫 보상까지의 여정',
    content: '버그바운티를 시작한 지 3개월 만에 첫 보상을 받기까지의 과정을 공유합니다. 어떤 프로그램을 선택했고, 어떻게 공부했으며, 어떤 실수를 했는지 솔직하게 이야기합니다. 초보자들이 피해야 할 함정과 효율적인 학습 방법을 제시합니다.',
    tags: ['bugbounty', 'beginner', 'guide', 'first-bounty', 'learning'],
    status: 'open',
    is_pinned: false,
    likes_count: 3890,
    replies_count: 142,
    views_count: 31500,
    created_at: new Date(Date.now() - 9 * 3600000).toISOString(),
    profiles: {
      id: 'user135',
      username: 'newbie_hunter',
      display_name: 'Newbie Hunter',
      points: 8920,
      reputation: 2560
    }
  },
  {
    id: 'bb6',
    user_id: 'user136',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Apple Security Bounty $100,000 - iOS Kernel 익스플로잇',
    content: 'Apple Security Bounty에서 최고 등급 보상인 $100,000를 받은 iOS 커널 취약점을 공개합니다. 제로클릭 익스플로잇 체인 구성과 샌드박스 탈출까지의 과정을 설명합니다. Apple의 까다로운 검증 과정과 소통 경험도 공유합니다.',
    tags: ['bugbounty', 'apple', 'ios', 'kernel', 'zero-click'],
    status: 'open',
    is_pinned: false,
    likes_count: 4567,
    replies_count: 167,
    views_count: 37800,
    created_at: new Date(Date.now() - 11 * 3600000).toISOString(),
    profiles: {
      id: 'user136',
      username: 'ios_pwner',
      display_name: 'iOS Pwner',
      points: 23450,
      reputation: 7340
    }
  },
  {
    id: 'bb7',
    user_id: 'user137',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'XSS에서 RCE까지 - 단계별 권한 상승 사례',
    content: '단순한 Reflected XSS를 발견하고 이를 RCE까지 확장한 사례를 공유합니다. XSS → CSRF → SSRF → RCE로 이어지는 공격 체인을 구성하는 과정과 각 단계에서의 창의적인 우회 기법을 설명합니다.',
    tags: ['bugbounty', 'xss', 'rce', 'privilege-escalation', 'chain'],
    status: 'open',
    is_pinned: false,
    likes_count: 2789,
    replies_count: 98,
    views_count: 22700,
    created_at: new Date(Date.now() - 13 * 3600000).toISOString(),
    profiles: {
      id: 'user137',
      username: 'chain_builder',
      display_name: 'Chain Builder',
      points: 16670,
      reputation: 5120
    }
  },
  {
    id: 'bb8',
    user_id: 'user138',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Bugcrowd MVP 달성 - 효율적인 리포트 작성법',
    content: 'Bugcrowd에서 MVP(Most Valuable Player)를 달성한 경험을 공유합니다. 좋은 리포트의 조건, 재현 단계 작성법, 영향도 평가 방법, 그리고 트리아지 팀과의 효과적인 소통 방법을 다룹니다. 실제 리포트 샘플도 제공합니다.',
    tags: ['bugbounty', 'bugcrowd', 'report-writing', 'mvp', 'communication'],
    status: 'open',
    is_pinned: false,
    likes_count: 2345,
    replies_count: 87,
    views_count: 19100,
    created_at: new Date(Date.now() - 15 * 3600000).toISOString(),
    profiles: {
      id: 'user138',
      username: 'report_master',
      display_name: 'Report Master',
      points: 15230,
      reputation: 4680
    }
  },
  {
    id: 'bb9',
    user_id: 'user139',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'API 보안 테스팅 - GraphQL 취약점 찾기',
    content: 'GraphQL API에서 버그바운티 보상을 받은 취약점들을 정리했습니다. 인트로스펙션 악용, 배치 쿼리 공격, 깊이 제한 우회 등 GraphQL 특유의 취약점 패턴과 테스팅 방법론을 공유합니다. 자동화 도구 활용법도 포함됩니다.',
    tags: ['bugbounty', 'api', 'graphql', 'testing', 'automation'],
    status: 'open',
    is_pinned: false,
    likes_count: 2567,
    replies_count: 92,
    views_count: 20800,
    created_at: new Date(Date.now() - 17 * 3600000).toISOString(),
    profiles: {
      id: 'user139',
      username: 'api_hunter',
      display_name: 'API Hunter',
      points: 14890,
      reputation: 4560
    }
  },
  {
    id: 'bb10',
    user_id: 'user140',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Microsoft $30,000 보상 - Azure AD 권한 상승',
    content: 'Microsoft Bug Bounty에서 $30,000를 받은 Azure AD 권한 상승 취약점을 공개합니다. 잘못 설정된 RBAC 권한과 API 엔드포인트 조합으로 테넌트 전체를 장악할 수 있었습니다. 클라우드 환경 테스팅 노하우를 공유합니다.',
    tags: ['bugbounty', 'microsoft', 'azure-ad', 'privilege-escalation', 'cloud'],
    status: 'open',
    is_pinned: false,
    likes_count: 3123,
    replies_count: 108,
    views_count: 25600,
    created_at: new Date(Date.now() - 19 * 3600000).toISOString(),
    profiles: {
      id: 'user140',
      username: 'cloud_bounty',
      display_name: 'Cloud Bounty Hunter',
      points: 17450,
      reputation: 5340
    }
  },
  {
    id: 'bb11',
    user_id: 'user141',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 자동화 - 커스텀 도구 개발기',
    content: '버그바운티 효율을 10배 높인 커스텀 자동화 도구 개발 경험을 공유합니다. 정찰, 취약점 스캔, 리포트 생성까지 자동화한 파이프라인을 구축했습니다. 오픈소스로 공개한 도구의 아키텍처와 활용법을 설명합니다.',
    tags: ['bugbounty', 'automation', 'tools', 'efficiency', 'development'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 103,
    views_count: 23400,
    created_at: new Date(Date.now() - 21 * 3600000).toISOString(),
    profiles: {
      id: 'user141',
      username: 'automation_dev',
      display_name: 'Automation Developer',
      points: 16230,
      reputation: 4980
    }
  },
  {
    id: 'bb12',
    user_id: 'user142',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Duplicate 리포트 피하기 - 독특한 취약점 찾는 법',
    content: 'Duplicate로 종료되는 리포트를 줄이고 독특한 취약점을 찾는 방법을 공유합니다. 다른 헌터들이 놓치는 엣지 케이스 찾기, 비인기 기능 테스팅, 그리고 창의적인 공격 벡터 개발 노하우를 다룹니다.',
    tags: ['bugbounty', 'duplicate', 'unique', 'edge-case', 'strategy'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 89,
    views_count: 19700,
    created_at: new Date(Date.now() - 23 * 3600000).toISOString(),
    profiles: {
      id: 'user142',
      username: 'unique_finder',
      display_name: 'Unique Finder',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'bb13',
    user_id: 'user143',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Tesla Bug Bounty $15,000 - 차량 원격 제어 취약점',
    content: 'Tesla Bug Bounty Program에서 $15,000를 받은 차량 원격 제어 취약점을 공개합니다. 모바일 앱의 API 취약점을 통해 다른 사용자의 차량을 제어할 수 있었습니다. IoT/자동차 보안 테스팅의 독특한 접근법을 설명합니다.',
    tags: ['bugbounty', 'tesla', 'iot', 'automotive', 'remote-control'],
    status: 'open',
    is_pinned: false,
    likes_count: 3678,
    replies_count: 134,
    views_count: 29800,
    created_at: new Date(Date.now() - 25 * 3600000).toISOString(),
    profiles: {
      id: 'user143',
      username: 'car_hacker',
      display_name: 'Car Hacker',
      points: 18890,
      reputation: 5780
    }
  },
  {
    id: 'bb14',
    user_id: 'user144',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '모바일 앱 버그바운티 - Android/iOS 테스팅 가이드',
    content: '모바일 앱에서 고액 보상을 받은 취약점들을 정리했습니다. 인증 우회, 로컬 데이터 탈취, 딥링크 악용 등 모바일 특유의 취약점 패턴을 다룹니다. Frida, Objection 등 필수 도구 활용법도 포함됩니다.',
    tags: ['bugbounty', 'mobile', 'android', 'ios', 'frida'],
    status: 'open',
    is_pinned: false,
    likes_count: 2789,
    replies_count: 96,
    views_count: 22100,
    created_at: new Date(Date.now() - 27 * 3600000).toISOString(),
    profiles: {
      id: 'user144',
      username: 'mobile_bounty',
      display_name: 'Mobile Bounty Hunter',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 'bb15',
    user_id: 'user145',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Shopify $25,000 보상 - 결제 로직 우회',
    content: 'Shopify Bug Bounty에서 $25,000를 받은 결제 로직 우회 취약점을 공개합니다. 레이스 컨디션과 정수 오버플로우를 조합하여 무료로 상품을 구매할 수 있었습니다. 전자상거래 플랫폼 테스팅의 핵심 포인트를 설명합니다.',
    tags: ['bugbounty', 'shopify', 'payment', 'race-condition', 'ecommerce'],
    status: 'open',
    is_pinned: false,
    likes_count: 3234,
    replies_count: 112,
    views_count: 26400,
    created_at: new Date(Date.now() - 29 * 3600000).toISOString(),
    profiles: {
      id: 'user145',
      username: 'payment_breaker',
      display_name: 'Payment Breaker',
      points: 17230,
      reputation: 5340
    }
  },
  {
    id: 'bb16',
    user_id: 'user146',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 세금 처리 - 해외 소득 신고 가이드',
    content: '버그바운티로 받은 해외 소득의 세금 처리 방법을 상세히 설명합니다. 종합소득세 신고, 외화 환산, 필요 경비 인정 범위 등 실전 경험을 바탕으로 정리했습니다. 세무사 상담 내용과 실제 신고 사례도 공유합니다.',
    tags: ['bugbounty', 'tax', 'income', 'korea', 'guide'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 17200,
    created_at: new Date(Date.now() - 31 * 3600000).toISOString(),
    profiles: {
      id: 'user146',
      username: 'tax_expert',
      display_name: 'Tax Expert Hunter',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 'bb17',
    user_id: 'user147',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Netflix $20,000 보상 - 계정 탈취 취약점 체인',
    content: 'Netflix Bug Bounty에서 $20,000를 받은 계정 탈취 취약점을 공개합니다. 이메일 검증 우회, 세션 고정, 그리고 2FA 우회를 연계한 복잡한 공격이었습니다. 스트리밍 서비스 특유의 보안 메커니즘과 테스팅 포인트를 설명합니다.',
    tags: ['bugbounty', 'netflix', 'account-takeover', '2fa-bypass', 'streaming'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 101,
    views_count: 23700,
    created_at: new Date(Date.now() - 33 * 3600000).toISOString(),
    profiles: {
      id: 'user147',
      username: 'streaming_hunter',
      display_name: 'Streaming Hunter',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'bb18',
    user_id: 'user148',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'SSRF 마스터 클래스 - 내부망 침투 기법',
    content: 'SSRF 취약점으로 여러 고액 보상을 받은 경험을 정리했습니다. 블랙리스트 우회, 프로토콜 스머글링, 클라우드 메타데이터 접근 등 고급 SSRF 기법을 다룹니다. AWS, GCP, Azure 환경별 공격 시나리오도 포함됩니다.',
    tags: ['bugbounty', 'ssrf', 'cloud', 'metadata', 'bypass'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 94,
    views_count: 21800,
    created_at: new Date(Date.now() - 35 * 3600000).toISOString(),
    profiles: {
      id: 'user148',
      username: 'ssrf_master',
      display_name: 'SSRF Master',
      points: 15450,
      reputation: 4680
    }
  },
  {
    id: 'bb19',
    user_id: 'user149',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Uber $18,000 보상 - 위치 정보 조작 취약점',
    content: 'Uber Bug Bounty에서 $18,000를 받은 위치 정보 조작 취약점을 공개합니다. GPS 스푸핑과 API 조작을 통해 요금을 부정하게 낮출 수 있었습니다. 위치 기반 서비스의 보안 취약점과 테스팅 방법론을 설명합니다.',
    tags: ['bugbounty', 'uber', 'location', 'gps-spoofing', 'api'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 87,
    views_count: 19900,
    created_at: new Date(Date.now() - 37 * 3600000).toISOString(),
    profiles: {
      id: 'user149',
      username: 'location_hacker',
      display_name: 'Location Hacker',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'bb20',
    user_id: 'user150',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 멘탈 관리 - 거절과 실패 극복하기',
    content: '수십 번의 거절과 Duplicate를 경험하며 배운 멘탈 관리 방법을 공유합니다. 번아웃 예방, 동기 부여 유지, 그리고 실패를 학습 기회로 전환하는 마인드셋을 다룹니다. 장기적으로 성공하는 헌터의 특징도 분석합니다.',
    tags: ['bugbounty', 'mental-health', 'motivation', 'failure', 'mindset'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 82,
    views_count: 18100,
    created_at: new Date(Date.now() - 39 * 3600000).toISOString(),
    profiles: {
      id: 'user150',
      username: 'mental_coach',
      display_name: 'Mental Coach',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 'bb21',
    user_id: 'user151',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'GitHub $12,000 보상 - Actions 워크플로우 인젝션',
    content: 'GitHub Security Bug Bounty에서 $12,000를 받은 Actions 워크플로우 인젝션 취약점을 공개합니다. 악의적인 PR을 통해 시크릿 키를 탈취할 수 있었습니다. CI/CD 파이프라인 보안 테스팅의 핵심 포인트를 설명합니다.',
    tags: ['bugbounty', 'github', 'actions', 'cicd', 'injection'],
    status: 'open',
    is_pinned: false,
    likes_count: 2567,
    replies_count: 91,
    views_count: 20800,
    created_at: new Date(Date.now() - 41 * 3600000).toISOString(),
    profiles: {
      id: 'user151',
      username: 'cicd_hunter',
      display_name: 'CI/CD Hunter',
      points: 15890,
      reputation: 4890
    }
  },
  {
    id: 'bb22',
    user_id: 'user152',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 타겟 선정 - 수익성 높은 프로그램 찾기',
    content: '효율적인 버그바운티 타겟 선정 전략을 공유합니다. 보상 금액, 스코프, 경쟁 강도, 응답 속도 등을 종합적으로 분석하여 최적의 프로그램을 선택하는 방법을 설명합니다. 숨겨진 보석 같은 프로그램 찾는 팁도 제공합니다.',
    tags: ['bugbounty', 'target-selection', 'strategy', 'roi', 'efficiency'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 98,
    views_count: 23400,
    created_at: new Date(Date.now() - 43 * 3600000).toISOString(),
    profiles: {
      id: 'user152',
      username: 'target_analyst',
      display_name: 'Target Analyst',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'bb23',
    user_id: 'user153',
    type: 'feed' as const,
    category: 'bugbounty',
    title: 'Airbnb $22,000 보상 - 예약 시스템 로직 버그',
    content: 'Airbnb Bug Bounty에서 $22,000를 받은 예약 시스템 로직 버그를 공개합니다. 타임존 처리 오류와 환불 로직 결함을 조합하여 무료 숙박이 가능했습니다. 복잡한 비즈니스 로직 테스팅 방법론을 설명합니다.',
    tags: ['bugbounty', 'airbnb', 'business-logic', 'booking', 'payment'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 93,
    views_count: 21700,
    created_at: new Date(Date.now() - 45 * 3600000).toISOString(),
    profiles: {
      id: 'user153',
      username: 'logic_breaker',
      display_name: 'Logic Breaker',
      points: 16450,
      reputation: 5010
    }
  },
  {
    id: 'bb24',
    user_id: 'user154',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 협업 - 팀으로 일하는 방법',
    content: '다른 헌터들과 협업하여 복잡한 취약점을 발견한 경험을 공유합니다. 역할 분담, 수익 배분, 커뮤니케이션 방법 등 팀 버그바운티의 노하우를 다룹니다. 혼자서는 불가능했던 고액 보상 사례도 소개합니다.',
    tags: ['bugbounty', 'collaboration', 'teamwork', 'partnership', 'strategy'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 15300,
    created_at: new Date(Date.now() - 47 * 3600000).toISOString(),
    profiles: {
      id: 'user154',
      username: 'team_hunter',
      display_name: 'Team Hunter',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'bb25',
    user_id: 'user155',
    type: 'feed' as const,
    category: 'bugbounty',
    title: '버그바운티 2025 트렌드 - AI/ML 시스템 테스팅',
    content: '2025년 버그바운티의 새로운 트렌드인 AI/ML 시스템 보안 테스팅을 다룹니다. 프롬프트 인젝션, 모델 포이즈닝, 데이터 추출 공격 등 AI 특유의 취약점 패턴을 설명합니다. 실제 보상을 받은 사례와 함께 미래 전망도 제시합니다.',
    tags: ['bugbounty', 'ai-security', 'ml', 'prompt-injection', '2025'],
    status: 'open',
    is_pinned: false,
    likes_count: 3456,
    replies_count: 127,
    views_count: 28200,
    created_at: new Date(Date.now() - 49 * 3600000).toISOString(),
    profiles: {
      id: 'user155',
      username: 'ai_bounty_hunter',
      display_name: 'AI Bounty Hunter',
      points: 17890,
      reputation: 5450
    }
  }
];